<div class="modal-header">
	<h2 [translate]="'Actions.AddUsers'"></h2>
	<button type="button" class="modal-button-close far fa-times" (click)="activeModal.dismiss()"></button>
</div>

<form [formGroup]="form"  autocomplete="off">
	<div class="modal-body">
		<div class="row">
			<div class="col-lg-8">
				<div class="form-group">
					<label class="form-label form-label-required" for="field-userName" translate="UserForm.Email"></label>
					<input class="form-control form-control-alt" formControlName="userName"
						[class.is-invalid]="userNameField.dirty && userNameField.invalid" />
					<form-control-feedback [field]="userNameField" />
				</div>
			</div>
			<div class="form-actions addEmail">
				<button [disabled]="userNameField.invalid" type="submit" (click)="addToGuestsList()">
					<i class="fas fa-plus-circle"></i>
				</button>
			</div>
		</div>
		<div class="form-user-list my-3">
			@for (control of guestsList.controls; track control; let n = $index) {
				<ng-container [formGroup]="control">
					<div class="row">
						<div class="col-3">
							<div class="form-group">
								<input class="form-control form-control-alt"
									[attr.disabled]="true"
									[value]="control.value['userName']"
									formControlName="userName"
									[placeholder]="('UserForm.Email' | translate) + ' *'"
									[class.is-invalid]="control.get('userName').dirty && control.get('userName').invalid"
								/>
								<form-control-feedback [field]="control.get('userName')" />
							</div>
						</div>
						@if (control.get('firstName')) {
							<div class="col-3">
								<div class="form-group">
									<input class="form-control form-control-alt"
										[value]="control.value['firstName']"
										formControlName="firstName"
										[placeholder]="('UserForm.FirstName' | translate) + ' *'"
										[class.is-invalid]="control.get('firstName').dirty && control.get('firstName').invalid"
									/>
									<form-control-feedback [field]="control.get('firstName')" />
								</div>
							</div>
						}
						@if (control.get('lastName')) {
							<div class="col-3">
								<div class="form-group">
									<input class="form-control form-control-alt"
										[value]="control.value['lastName']"
										formControlName="lastName"
										[placeholder]="('UserForm.LastName' | translate) + ' *'"
										[class.is-invalid]="control.get('lastName').dirty && control.get('lastName').invalid"
									/>
									<form-control-feedback [field]="control.get('lastName')" />
								</div>
							</div>
						}
						@if (control.get('subsidiaryRole')) {
							<div class="col-2">
								<div class="form-group">
									<select type="text" autocomplete="off"
										class="form-control form-control-alt"
										formControlName="subsidiaryRole">
										@for (role of roles(); track role) {
											<option [value]="role">
												{{ ('Roles.' + (role | uppercase)) | translate }}
											</option>
										}
									</select>
								</div>
								<form-control-feedback [field]="control.get('subsidiaryRole')" />
							</div>
						}
						<div class="col-1">
							<button (click)="removeInvite(n)" class="btn" type="button" data-cy="Delete"><i class="fa fa-trash"></i></button>
						</div>
					</div>
				</ng-container>
			}
		</div>
	</div>

	<div class="modal-footer">
		<button class="btn btn-default" type="button" translate="Actions.Cancel" data-cy="Cancel"
			(click)="activeModal.dismiss()"></button>
		<button class="btn btn-primary" type="submit" translate="Actions.Invite" data-cy="Invite" (click)="onSubmit()"
			[disabled]="guestsList.length === 0 || guestsListIsInvalid()"></button>
	</div>
</form>
